<template>
	<li class="estimate_card_container">
		<div :class="`heading_6 ${getStatusColor()}`">
			{{ item.estimateStatusCodeName }}
		</div>
		<ul class="estimate_info_list">
			<li>
				<p class="body_7 f_gray_4">견적번호</p>
				<b class="body_7_M">{{ item.estimateNo }}</b>
			</li>
			<li>
				<p class="body_7 f_gray_4">견적일자</p>
				<b class="body_7_M">{{ item.estimateDate }}</b>
			</li>
			<li>
				<p class="body_7 f_gray_4">차종</p>
				<b class="body_7_M">
					{{ item.brandName }}
					<span class="body_10_M f_gray_4">{{ item.vehicleTypeName }}</span>
				</b>
			</li>
			<li>
				<p class="body_7 f_gray_4">견적금액</p>
				<b class="body_7_M">{{ isPrice }}</b>
			</li>
		</ul>
		<div v-if="item.estimateStatusCode !== 10" class="button_wrapper">
			<Button
				v-if="item.estimateStatusCode === '20'"
				:size="36"
				:label="'결제하고 견적 확인하기'"
				:onClick="() => handlePayment(item.estimateSeq)" />
			<Button
				v-if="item.estimateStatusCode === '30'"
				:size="36"
				:label="'상세보기'"
				:color="'gray'"
				:onClick="() => handleDetail(item.estimateSeq, item.datEstimateNo)" />
			<Button
				v-if="item.estimateStatusCode === '40'"
				:size="36"
				:label="'견적상담'"
				:onClick="() => handleConsult(item.estimateSeq, item.datEstimateNo)" />
		</div>
	</li>
</template>

<script>
import Vue from 'vue'
import Button from '../AiButton.vue'

export default {
	props: {
		item: {
			type: Object
		}
	},
	computed:{
		isPrice(){
			if(this.item.msg.indexOf('원') > -1){
				return Math.round(this.item.msg.split('원')[0]).toLocaleString() + '원'
			} else {
				return this.item.msg;
			}
		}
	},
	methods: {
		getStatusColor() {
			switch (this.item.estimateStatusCode) {
				case '10':
				case '20':
					return 'f_red_3'
				case '40':
					return 'f_green_3'
			}
		},
		handlePayment(estimateSeq) {
			Vue.$sessionStorage.set('redirectseq', estimateSeq);
			this.$router.push({ name: 'AiPayment'})
		},
		handleDetail(estimateSeq, datEstimateNo) {
			Vue.$sessionStorage.set('redirectseq', estimateSeq);
			Vue.$sessionStorage.set('datEstimateNo', datEstimateNo);
			this.$router.push({ name: 'AiEstimate'})
		},
		handleConsult(estimateSeq, datEstimateNo) {
			Vue.$sessionStorage.set('redirectseq', estimateSeq);
			Vue.$sessionStorage.set('datEstimateNo', datEstimateNo);
			this.$router.push({ name: 'AiShopList'})
		}

	},
	components: {
		Button
	}
}
</script>

<style scoped>
.estimate_card_container {
	padding: 24px 20px;
	border-top: 8px solid var(--gray-scale-10);
}

.estimate_info_list {
	display: grid;
	gap: 12px;
}

.estimate_info_list>li {
	display: flex;
	align-items: flex-start;
	margin-top: 12px;
}

.estimate_info_list>li>p {
	min-width: 64px;
}

.estimate_info_list>li>b {
	display: grid;
}

.estimate_card_container>.button_wrapper {
	margin-top: 16px;
	display: flex;
	align-items: center;
	gap: 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/ai/card/AiEstimateItemCard.vue